import React from 'react';
interface TimelineCardProps {
  range: string;
  title: string;
  description: string;
}
const timelineData: TimelineCardProps[] = [{
  range: '1–2',
  title: 'Weeks 1–2: Sleep and Calm First',
  description: 'Most users notice improved sleep quality and a reduction in the baseline anxiety and tension that accompanies chronic gut dysfunction before significant gut changes occur. The vagus nerve\'s effect on the parasympathetic nervous system is the first to respond to daily stimulation. Many users describe this as feeling "less braced" — a reduction in the constant low-level alertness that chronic pain and urgency creates.'
}, {
  range: '2–4',
  title: 'Weeks 2–4: Gut Motility Begins to Shift',
  description: 'As the Migrating Motor Complex starts running more consistently, the characteristic bloating and the mid-day distension begin to reduce. Bowel regularity typically improves during this window. The 2024 AJG trial showed significant bowel movement improvement within four weeks — this is the timeline we aim for and the timeline we are honest about. Results are cumulative, not immediate.'
}, {
  range: '4–12',
  title: 'Weeks 4–12: Inflammation Reduction and Dietary Freedom',
  description: 'As the cholinergic anti-inflammatory pathway is progressively restored, the systemic inflammation driving food sensitivities, fatigue, brain fog, and gut wall permeability begins to reduce. Many users report being able to reintroduce foods they had eliminated — not because the foods changed, but because the gut environment that was reacting to them has. This is the window where the condition begins to shift rather than just the symptoms.'
}];
export function TimelineExpectations() {
  return <div className="my-16" data-id="element-242">
      <h3 className="text-2xl font-serif font-medium text-forest mb-8 text-center" data-id="element-243">
        What to Expect — An Honest Timeline
      </h3>
      <div className="space-y-6" data-id="element-244">
        {timelineData.map((item, idx) => <div key={idx} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-taupe/20 flex flex-col sm:flex-row gap-6 sm:gap-8 items-start" data-id="element-245">
            <div className="flex-shrink-0 flex flex-col items-center justify-center w-20 h-20 rounded-2xl bg-beige text-forest font-serif" data-id="element-246">
              <span className="text-2xl font-medium leading-none" data-id="element-247">
                {item.range}
              </span>
              <span className="text-[10px] uppercase tracking-widest mt-1 opacity-70" data-id="element-248">
                Weeks
              </span>
            </div>
            <div data-id="element-249">
              <h4 className="text-xl font-serif font-medium text-forest mb-3" data-id="element-250">
                {item.title}
              </h4>
              <p className="text-ink/80 leading-relaxed m-0" data-id="element-251">
                {item.description}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}